import React from "react";
import { Minus, Plus } from "lucide-react";

interface QuantityStepperProps {
    qty: number;
    onIncrement?: () => void;
    onDecrement?: () => void;
    className?: string;
    iconSize?: number;
    textSize?: string;
}

const QuantityStepper: React.FC<QuantityStepperProps> = ({
    qty,
    onIncrement,
    onDecrement,
    className = "",
    iconSize = 16,
    textSize = "text-sm",
}) => {
    return (
        <div
            className={`flex items-center h-[40px] rounded-md overflow-hidden border border-logoHeading bg-white w-full ${className}`}
        >
            <button
                onClick={onDecrement}
                className="flex-1 h-full flex items-center justify-center text-logoHeading hover:bg-gray-50 active:bg-gray-100"
            >
                <Minus size={iconSize} strokeWidth={2.5} />
            </button>

            <div className="w-px h-5 bg-accent" />

            <div className={`flex-1 flex items-center justify-center ${textSize} font-medium text-logoHeading`}>
                {qty}
            </div>

            <div className="w-px h-5 bg-accent" />

            <button
                onClick={onIncrement}
                className="flex-1 h-full flex items-center justify-center text-logoHeading hover:bg-gray-50 active:bg-gray-100"
            >
                <Plus size={iconSize} strokeWidth={2.5} />
            </button>
        </div>
    );
};

export default QuantityStepper;